import { Slide } from '@/types/slide';
import { gql } from '@apollo/client';
import { ClassModel, HomeworkModel } from './types/homework';

export type GetHomeworkVariables = {
    skip: number;
    take: number;
    where: {
        teacher: {
            id: {
                equals: string;
            };
        };
        isArchived?: {
            equals: boolean;
        };
        endTime?: {
            gt?: string;
            lte?: string;
        };
    };
};

export type GetHomeworksResponse = {
    homeworks: HomeworkModel[];
    homeworksCount: number;
};

export const GET_HOMEWORKS = gql`
    query GetHomework($skip: Int!, $take: Int!, $where: HomeworkWhereInput!, $orderBy: [HomeworkOrderByInput!]!) {
        homeworks(skip: $skip, take: $take, orderBy: $orderBy, where: $where) {
            id
            homeworkName
            lessonVersion {
                id
                lessonName
            }
            class {
                id
                className
                schoolYear
            }
            startTime
            endTime
            serverTime
            isArchived
        }
        homeworksCount(where: $where)
    }
`;

export const ARCHIVE_HOMEWORK = gql`
    mutation UpdateHomeworks($data: [HomeworkUpdateArgs!]!) {
        updateHomeworks(data: $data) {
            id
        }
    }
`;

export type ArchiveHomeworkVariableType = {
    data: {
        data: {
            isArchived?: boolean;
        };
        where: {
            id: string;
        };
    }[];
};

export type ArchiveHomeworkResponseType = {
    updateHomeworks: { id: string }[];
};

export const GET_CLASSES = gql`
    query GetClasses {
        classes(orderBy: { className: asc }) {
            id
            school {
                schoolName
            }
            className
            schoolYear
        }
    }
`;

export type GetClassesResponse = {
    classes: ClassModel[];
};

export const LESSON_PUBLISH = gql`
    mutation LessonPublish($lessonID: ID!) {
        publishLesson(lessonID: $lessonID) {
            id
        }
    }
`;

export type LessonPublishVariables = {
    lessonID: string;
};

export type LessonPublishResponse = {
    publishLesson: { id: string };
};

export const CREATE_HOMEWORK = gql`
    mutation CreateHomework(
        $name: String!
        $lessonVersion: ID!
        $class: ClassRelateToManyForCreateInput!
        $writingHints: Boolean!
        $freeStyleMode: Boolean!
        $startTime: DateTime!
        $endTime: DateTime!
    ) {
        createHomework(
            data: {
                homeworkName: $name
                lessonVersion: { connect: { id: $lessonVersion } }
                class: $class
                writingHints: $writingHints
                freeStyleMode: $freeStyleMode
                startTime: $startTime
                endTime: $endTime
            }
        ) {
            id
            homeworkName
            lessonVersion {
                id
            }
            class {
                id
            }
            writingHints
            freeStyleMode
        }
    }
`;

export type CreateHomeworkVariables = {
    name: string;
    lessonVersion: string;
    class: ClassModel[];
    writingHints: boolean;
    freeStyleMode: boolean;
    startTime: Date;
    endTime: Date;
};

export type CreateHomeworkResponse = {
    createHomework: HomeworkModel;
};

export interface GetLessonVariables {
    where: {
        id: string;
    };
}

export interface GetLessonResponse {
    lesson: {
        id: string;
        latestLessonDraft: {
            id: string;
            lessonName: string;
            dateUpdated: string;
            slides: Slide[];
        };
    };
}

export const GET_LESSON = gql`
    query Lesson($where: LessonWhereUniqueInput!) {
        lesson(where: $where) {
            id
            latestLessonDraft {
                id
                lessonName
                slides(orderBy: { sort: asc }) {
                    id
                    data
                }
                dateUpdated
            }
        }
    }
`;

export interface GetLessonsResponse {
    lessons: GetLessonResponse['lesson'][];
}

export const GET_LESSONS = gql`
    query Lessons($skip: Int, $take: Int, $where: LessonWhereInput) {
        lessons(skip: $skip, take: $take, where: $where, orderBy: [{ dateUpdated: desc }]) {
            id
            latestLessonDraft {
                id
                lessonName
                published
                dateUpdated
            }
        }
    }
`;
